import { useEffect, useState } from 'react';
import { globalBus } from '../streams/wsBus';
import { useActionFeedback } from '../streams/useActionFeedback';

type BuildRow = [string, string, string];

export function BuildStackPanel() {
  const [rows, setRows] = useState<BuildRow[]>([]);
  const { states, fire } = useActionFeedback(globalBus);

  useEffect(() => {
    const unsub = globalBus.subscribe((message) => {
      if (message.t === 'scene' && message.id === 'hivecore.build') {
        setRows(message.body?.widgets?.find((w: any) => w.key === 'buildstacks.list')?.rows ?? []);
      }
    });
    globalBus.sendIntent('scene.request', { id: 'hivecore.build' });
    globalBus.sendIntent('buildstacks.refresh');
    return unsub;
  }, []);

  const refresh = () => fire('buildstacks.refresh.btn', 'buildstacks.refresh');
  const rerun = (name: string) => fire(`buildstacks.rerun.${name}`, 'buildstacks.rerun', { name });
  const openLogs = (name: string) => globalBus.sendIntent('buildstacks.openLogs', { name });

  return (
    <div className="panel">
      <header className="panel-header">
        <h2>BuildStacks</h2>
        <button data-state={states['buildstacks.refresh.btn'] ?? 'idle'} onClick={refresh}>Refresh</button>
      </header>
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Status</th>
            <th>Updated</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={4} style={{ textAlign: 'center', padding: '24px', color: 'var(--muted)' }}>
                No buildstacks.
              </td>
            </tr>
          ) : (
            rows.map(([name, status, updated]) => (
              <tr key={name}>
                <td>{name}</td>
                <td>{status}</td>
                <td>{new Date(updated).toLocaleTimeString()}</td>
                <td style={{ display: 'flex', gap: '8px' }}>
                  <button data-state={states[`buildstacks.rerun.${name}`] ?? 'idle'} onClick={() => rerun(name)}>Rerun</button>
                  <button onClick={() => openLogs(name)}>Open Logs</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
